import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import Form from "react-bootstrap/Form";
import Modal from 'react-bootstrap/Modal';
import Button from "react-bootstrap/Button";
import * as Yup from 'yup';
import { Formik } from 'formik';
import { updatePassword } from "../reducers/users";
import AddressModal from "./modals/AddressModal";
import SwitchSiteModal from './modals/SwitchSiteModal';
import { getSubsite } from '../reducers/auth';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { PersonCircle,Person, Lock, Bank, CashCoin, Envelope, GeoAltFill, BagFill } from 'react-bootstrap-icons';
import { getUser, reloadUser } from '../reducers/auth';

const Profile = () => {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const currentUser  = useSelector(getUser);
  const { isLoggedIn } = useSelector(state => state.auth);
  const [ passwordModalShow, setPasswordModalShow ] = useState(false);
  const [ addressModalShow, setAddressModalShow ] = useState(false);
  const [ siteModalShow, setSiteModalShow ] = useState(false);
  const currentSubsite = useSelector(getSubsite);

  const handlePasswordClick = (values, {setSubmitting, resetForm}) => {
    //setSubmitting(true);
  
    dispatch(updatePassword(values));

    setPasswordModalShow(false);

  }
  
  const closeSiteModal = () => {
    setSiteModalShow(false);
  }
  const showSiteModal = () => {
    setSiteModalShow(true);
  }

  const showPasswordModal = () => {
    setPasswordModalShow(true);
  }

  const passwordModalClose = () => {
    setPasswordModalShow(false);
  }
  const handleAddressClick = (values, {setSubmitting, resetForm}) => {
    //setSubmitting(true);
  
    //dispatch(updatePassword(values));

    setAddressModalShow(false);

  }

  const closeAddressModal = () => {
    setAddressModalShow(false);
  }
  const showAddressModal = () => {
    setAddressModalShow(true);
  }


  useEffect(() => {
    if (!currentUser) {
      navigate("/login");
    }
  }, [currentUser]);

  // Schema for yup
  const validationSchema = Yup.object().shape({
    currentPassword: Yup.string()
      .required("*Password is required"),
    newPassword: Yup.string()
      .min(8, "*Passwords must be 8 characters")
      .max(100, "*Passwords can't be longer than 100 characters")
      .required("*New Password is required"),
    confirmNewPassword: Yup.string()
      .oneOf([Yup.ref('newPassword'), null], 'Passwords must match')
    });

    // Schema for yup
  const addressValidationSchema = Yup.object().shape({
    street: Yup.string()
      .required("*Street is required"),
    city: Yup.string()
      .required("*City is required"),
    state: Yup.string()
      .required("*State is required"),
    zip: Yup.string()
      .required("*Zip Code is required")
      .min(5, "*Zip Code must be at least 5 digits")
      .max(10, "*Zip Code can't be more than 10 digits"),
  });

  return (
    <Container className="user-data">
        <Row>
            <Col className="icon">
                <PersonCircle size={60}/>
                <Col className="header">{currentUser?.firstname} {currentUser?.lastname}</Col>
            </Col>
        </Row>
        <Row>
            <Col>
                <hr/>
            </Col>
        </Row>
        <Row>
            <Col className="icon">
                <Person size={40}/>
            </Col>
        </Row>
        <Row>
            <Col className="title" xs={3}>Username</Col>
            <Col className="value">{currentUser?.email}</Col>
        </Row>
        <Row>
            <Col>
                <hr/>
            </Col>
        </Row>
        <Row>
            <Col className="icon">
                <Envelope size={40}/>
            </Col>
        </Row>
        <Row>
            <Col className="title" xs={3}>Email Address</Col>
            <Col className="value">{currentUser?.email}</Col>
        </Row>
        <Row>
            <Col>
                <hr/>
            </Col>
        </Row>
        <Row>
            <Col className="icon">
                <GeoAltFill size={40}/>
            </Col>
        </Row>
        <Row>
            <Col>
                <hr/>
            </Col>
        </Row>
        <Row>
            <Col className="icon">
                <Lock size={40}/>
            </Col>
        </Row>
        <Row>
            <Col className="title" xs={3}>Password</Col>
            <Col className="value">
                <Button size="sm" variant="outline-secondary"  onClick={showPasswordModal}>Reset Password</Button>
            </Col>
        </Row>
        <Row>
            <Col>
                <hr/>
            </Col>
        </Row>
        <Row>
            <Col className="icon">
                <CashCoin size={40}/>
            </Col>
        </Row>
        <Row>
            <Col className="title" xs={3}>Balance</Col>
            <Col className="value">
                ${currentUser?.subsiteBalance?.balance}<br/><br/>
                Missing your balance? <Button onClick={() => dispatch(reloadUser())}>Reload User</Button>
            </Col>
        </Row>
        <Row>
            <Col>
                <hr/>
            </Col>
        </Row>
        <Row>
        <Col className="title" xs={3}>Current Site</Col>
        <Col className="value">
        {currentUser && currentUser.subsites && (
            <>{currentSubsite.subsiteName}</> 
          )}
          {currentUser && currentUser.subsites && currentUser.subsites.length > 1 && (
            <><br/><br/><Button size="sm" variant="outline-secondary" onClick={showSiteModal}>Change Site</Button></>
          )}
          </Col>
        </Row>
        <Row>
            <Col>
                <hr/>
            </Col>
        </Row>
        <Row>
            <Col className="icon">
                <BagFill size={40}/>
            </Col>
        </Row>
        <Row>
            <Col className="title" xs={3}>Orders</Col>
            <Col className="value">Order #23 1/2/2023 $125.00</Col>
        </Row>

   

      <SwitchSiteModal show={siteModalShow} closeModal={closeSiteModal} />

      <Modal show={passwordModalShow} onHide={passwordModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Update Password<br/></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik 
            initialValues={{ currentPassword:"", newPassword:"", confirmNewPassword:""}}
            validationSchema={validationSchema}
            onSubmit={handlePasswordClick}
            >
            {/* Callback function containing Formik state and helpers that handle common form actions */}
              {( {values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting }) => (
                <Form onSubmit={handleSubmit} >
                  <Form.Group className="mb-3" controlId="currentPassword">
                    <Form.Label>Current Password</Form.Label>
                    <Form.Control 
                      name="currentPassword"
                      type="password"
                      placeholder="Current Password"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.currentPassword}
                      className={touched.currentPassword && errors.currentPassword ? "error" : null}
                    />
                    {touched.currentPassword && errors.currentPassword ? (
                      <div className="error-message">{errors.currentPassword}</div>
                    ): null}
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="newPassword">
                    <Form.Label>New Password</Form.Label>
                    <Form.Control
                      name="newPassword"
                      type="password"
                      placeholder="New Password"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.newPassword}
                      className={touched.newPassword && errors.newPassword ? "error" : null}
                    />
                    {touched.newPassword && errors.newPassword ? (
                      <div className="error-message">{errors.newPassword}</div>
                    ): null}
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="confirmNewPassword">
                    <Form.Label>Confirm New Password</Form.Label>
                    <Form.Control 
                      name="confirmNewPassword" 
                      type="password" 
                      placeholder="Confirm New Password"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.confirmNewPassword}
                      className={touched.confirmNewPassword && errors.confirmNewPassword ? "error" : null}
                    />
                    {touched.confirmNewPassword && errors.confirmNewPassword ? (
                        <div className="error-message">{errors.confirmNewPassword}</div>
                    ): null}
                  </Form.Group>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={passwordModalClose}>
                      Cancel
                    </Button>
                    <Button variant="primary" onClick={handlePasswordClick} type="submit" disabled={isSubmitting}>
                      Change Password
                    </Button>
                  </Modal.Footer>
                </Form>  
          )}
        </Formik>
        </Modal.Body>
      </Modal>
    </Container>
  );
};
export default Profile; 